import React from 'react'
import MainPage from './MainPage.js'
import MenuPage from './MenuPage.js'

export default function Home() {
  return (
    <MenuPage />
 

)
}
